
// Import global polyfill first
import './polyfills/global.js';

import { createRoot } from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { MetaPixel } from './components/MetaPixel.tsx'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Failed to find the root element");
} else {
  try {
    console.log("Mounting React application...");
    createRoot(rootElement).render(
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <MetaPixel />
            <App />
            <Analytics />
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    );
    console.log("Application mounted successfully");
  } catch (error) {
    console.error("Error rendering application:", error);
    // Display fallback UI in case of render error
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h2>Sorry, something went wrong</h2>
        <p>The application failed to load. Please try refreshing the page.</p>
        <pre style="text-align: left; margin-top: 20px; padding: 10px; background: #f5f5f5; border-radius: 4px; overflow: auto;">${error?.toString()}</pre>
      </div>
    `;
  }
}
